import { Button, Input, Select, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";

function ControlBox ({stateHandler}) {

  const insertHandler = () => {
    stateHandler("insertModal", true)
  }

  return (
    <Space wrap style={{justifyContent: "end"}}>
      <Button onClick={insertHandler}>
        <PlusOutlined />그룹 등록
      </Button>
    </Space>
  )
}

export default ControlBox